import { ExternalUnit } from '@chirp/engrain-client';

export function getInternalUnitId(unit: ExternalUnit) {
  return unit.chirpUnitId || unit.stratisUnitId || null;
}
